import React from "react";
import {
  Box,
  Typography,
  Divider,
  Checkbox,
  FormControlLabel,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const FiltersSidebar = ({
  activeFilters,
  onFilterChange,
  onClear,
  isMobile = false,
}) => {
  const { t } = useTranslation();

  const isChecked = (category, value) => {
    return activeFilters?.[category]?.includes(value) || false;
  };

  const handleChange = (category, value) => {
    onFilterChange(category, value);
  };

  return (
    <Box
      sx={{
        // Se for mobile, usa width 100%, sem border e padding ajustado
        width: isMobile ? "100%" : 250,
        padding: isMobile ? 0 : 2,
        border: isMobile ? "none" : "1px solid #e0e0e0",
        borderRadius: isMobile ? 0 : 2,
        height: "fit-content",
        backgroundColor: "#fff",
      }}
    >
      {/* Esconde o cabeçalho se for mobile, pois o DialogTitle já tem o título */}
      {!isMobile && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            {t("filters")}
          </Typography>
          <Button
            variant="text"
            color="primary"
            onClick={onClear}
            sx={{ textTransform: "none", fontSize: "0.85rem" }}
          >
            {t("clearFilters")}
          </Button>
        </Box>
      )}

      {!isMobile && <Divider sx={{ mb: 2 }} />}

      {/* --- Transmissão --- */}
      <Typography
        variant="subtitle2"
        fontWeight="bold"
        sx={{ mb: 1, mt: isMobile ? 2 : 0 }}
      >
        {t("gearbox")}
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked("transmission", "Manual")}
            onChange={() => handleChange("transmission", "Manual")}
          />
        }
        label={t("manual")}
        sx={{ display: "block" }}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked("transmission", "Automatic")}
            onChange={() => handleChange("transmission", "Automatic")}
          />
        }
        label={t("automatic")}
        sx={{ display: "block" }}
      />

      <Divider sx={{ my: 2 }} />

      {/* --- Combustível --- */}
      <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
        {t("fuelType")}
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked("fuel", "Petrol")}
            onChange={() => handleChange("fuel", "Petrol")}
          />
        }
        label={t("petrol")}
        sx={{ display: "block" }}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked("fuel", "Diesel")}
            onChange={() => handleChange("fuel", "Diesel")}
          />
        }
        label={t("diesel")}
        sx={{ display: "block" }}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked("fuel", "Hybrid")}
            onChange={() => handleChange("fuel", "Hybrid")}
          />
        }
        label={t("hybrid")}
        sx={{ display: "block" }}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked("category", "Electric")}
            onChange={() => handleChange("category", "Electric")}
          />
        }
        label={t("electricCar")}
        sx={{ display: "block" }}
      />

      <Divider sx={{ my: 2 }} />

      {/* --- Categoria --- */}
      <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
        {t("vehicleType")}
      </Typography>

      {/* Container para as categorias (Scrollável se necessário em mobile) */}
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked("category", "Small")}
              onChange={() => handleChange("category", "Small")}
            />
          }
          label={t("small")}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked("category", "Medium")}
              onChange={() => handleChange("category", "Medium")}
            />
          }
          label={t("medium")}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked("category", "Large")}
              onChange={() => handleChange("category", "Large")}
            />
          }
          label={t("large")}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked("category", "Cabrio")}
              onChange={() => handleChange("category", "Cabrio")}
            />
          }
          label={t("cabrio")}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked("category", "Suv")}
              onChange={() => handleChange("category", "Suv")}
            />
          }
          label={t("suv")}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked("category", "MiniVan")}
              onChange={() => handleChange("category", "MiniVan")}
            />
          }
          label={t("miniVan")}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked("category", "Premium")}
              onChange={() => handleChange("category", "Premium")}
            />
          }
          label={t("premium")}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked("category", "Van")}
              onChange={() => handleChange("category", "Van")}
            />
          }
          label={t("van")}
        />
      </Box>

      {/* Botão de Limpar Filtros VISÍVEL APENAS EM MOBILE (no final) */}
      {isMobile && (
        <Box sx={{ mt: 3, mb: 1, display: "flex", justifyContent: "center" }}>
          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            onClick={onClear}
          >
            {t("clearFilters")}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default FiltersSidebar;
